export default __webpack_public_path__ + "assets/courier_detail_view_header.png";